import { bibleBookChapterCounts, bibleBookKeys } from '../data/bibleBookChapters';

export type ReadingBookmark = { book: string; chapter: number };

export function parseReadingBookmark(value?: string): ReadingBookmark | null {
  if (!value) {
    return null;
  }
  try {
    const bookmark = JSON.parse(value);
    if (!bookmark || typeof bookmark.book !== 'string') {
      return null;
    }
    const book = bibleBookKeys.find(
      (key) => key.toLowerCase() === bookmark.book.toLowerCase().trim(),
    );
    const chapter = Number(bookmark.chapter);
    if (
      !book ||
      !Number.isInteger(chapter) ||
      chapter < 1 ||
      chapter > bibleBookChapterCounts[book]
    ) {
      return null;
    }
    return { book, chapter };
  } catch {
    return null;
  }
}

export function initialReadingPassage(hash: string, bookmark?: string): ReadingBookmark {
  const query = hash.includes('?') ? hash.slice(hash.indexOf('?') + 1) : '';
  if (new URLSearchParams(query).get('resume') === '1') {
    const saved = parseReadingBookmark(bookmark);
    if (saved) {
      return saved;
    }
  }
  return { book: 'genesis', chapter: 1 };
}
